<template>
  <v-content>
    <v-layout align-center justify-center column class="white">
      <v-flex>
        <v-card class="flex" justify-center align-center style="width:2311px; height:400px">
          <v-container fill-height fluid class="white" style="width:700px">
            <v-flex sm12 flexbox align-center justify-center text-xs-center>
              <v-card-text class="display-2">
                <span>Subscribe to our newsletter</span>
              </v-card-text>
              <v-card-text class="subheading">
                <span>Wot? How did you get here? It is not working anyways ¯\_(ツ)_/¯</span>
              </v-card-text>
              <v-text-field
                v-model="email"
                :rules="[rules.required, rules.email]"
                outline
                single-line
                label="Please enter your email address"
                type="email"
                class="my-input email-input"
              ></v-text-field>
              <v-btn flat @click.prevent="playSound('/others/WOW3.mp3')" class="email-submit">Submit</v-btn>
            </v-flex>
          </v-container>
          <v-card class="indigo lighten-4 left-circle"></v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
export default {
  data: () => ({
    password: "Password",
    show: false,
    marker: true,
    iconIndex: 0,
    icons: [
      "mdi-emoticon",
      "mdi-emoticon-cool",
      "mdi-emoticon-dead",
      "mdi-emoticon-excited",
      "mdi-emoticon-happy",
      "mdi-emoticon-neutral",
      "mdi-emoticon-sad",
      "mdi-emoticon-tongue"
    ],
    title: "Preliminary report",
    email: "",
    rules: {
      required: value => !!value || "Required.",
      counter: value => value.length <= 20 || "Max 20 characters",
      email: value => {
        const pattern = /^(([^<>()[]\.,;:\s@"]+(.[^<>()[]\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    }
  }),

  computed: {
    icon() {
      return this.icons[this.iconIndex];
    }
  },

  methods: {
    toggleMarker() {
      this.marker = !this.marker;
    },
    sendMessage() {
      this.resetIcon();
      this.clearMessage();
    },
    clearMessage() {
      this.message = "";
    },
    resetIcon() {
      this.iconIndex = 0;
    },
    changeIcon() {
      this.iconIndex === this.icons.length - 1
        ? (this.iconIndex = 0)
        : this.iconIndex++;
    },
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    }
  }
};
</script>

<style>
.email-input {
  width: 420px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.my-input.v-input .v-input__slot {
  border-radius: 300px;
}

.email-submit {
  position: absolute;
  margin-top: -77px;
  margin-left: 73px;
  color: black !important;
}

.left-circle {
  border-top-left-radius: 0;
  border-top-right-radius: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  width: 70px;
  height: 100px;
  position: relative;
  left: -20px;
  bottom: 100px;
}
</style>